<template>
  <div class="col-span-12">
    <div class="grid grid-cols-12 gap-4">
      <div class="col-span-12 mx-auto mt-4">
        <table class="w-full leading-normal text-gray"
               style="border: solid 1px #dedede;">
          <thead class="bg-gray-pale" >
          <tr>
            <th colspan="12" class="py-2">
              <span class="px-2" v-if="type !== 'private-company-limited-by-guarantee-without-shares'">Members</span>
              <span class="px-2" v-else>Subscribers</span>
            </th>
          </tr>
          </thead>
          <tbody>
           <LegalPersonsDetails class="p-1" :persons="getCompanySubscribers.data.content"/>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed, ref } from "vue";
import { useBusinessFileStore } from "@/stores/business-file";
import LegalPersonsDetails
  from "@/domains/home/services/registry/business/files/tabs/company_data/LegalPersonsDetails.vue";

const fileStore = useBusinessFileStore();

const type = ref<string | null>(null);
const getCompanySubscribers = computed(() => fileStore.subscribers);
</script>

